import axios from "axios";
import { config } from "../../../config";
import { IPerson } from "redmond";

import { passengersApiPrefix } from "../../paths";
import { replaceObjectValues } from "@capone/common";

const END_POINT: string = `${passengersApiPrefix}/update`;

export const updateUserPassenger = (
  body: IUpdateUserPassengerRequest
): Promise<IUpdateUserPassengerResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const { person, ...payload } = body;

      const cleanPersonPayload = replaceObjectValues(person, "", null);

      const res = await axios.put(
        END_POINT,
        { ...payload, person: cleanPersonPayload },
        {
          baseURL: config.baseURL,
        }
      );

      const responseBody: IUpdateUserPassengerResponse = res.data;
      resolve(responseBody);
    } catch (e) {
      reject(e);
    }
  });

export interface IUpdateUserPassengerRequest {
  person: IPerson;
}

export interface IUpdateUserPassengerResponse {}
